import React from 'react';

import * as S from './Radio.styles';

export const Radio = ({
  theme = 1,
  size = 'm',
  value,
  label,
  disabled,
  checked,
  name,
  ...rest
}) => {
  return (
    <S.Container theme={theme} size={size} {...rest}>
      <S.RadioButton name={name} disabled={disabled} checked={checked} value={value} readOnly />
      {label}
    </S.Container>
  );
};
